// extracted by mini-css-extract-plugin
export default {"shipment-table__wrapper":"CompletedSalesOrderTable_shipment-table__wrapper__0dE6s","shipment-table":"CompletedSalesOrderTable_shipment-table__3G4jo"};